import PropTypes from 'prop-types';

export const defaultProps = {};

export const propTypes = {
  id: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  email: PropTypes.string,
  photo: PropTypes.string,
  headline: PropTypes.string,
  language: PropTypes.string,
  currency: PropTypes.string,
  gender: PropTypes.string,
};

export default { defaultProps, propTypes };
